module.exports = __webpack_public_path__ + "img/close.766bb3a9.svg";